import { apiClient } from "lib/axios";

/**
 * Invitation APIs are company-scoped by backend context.
 *
 * Rules:
 * - Do NOT send companyId.
 * - Backend derives active company from httpOnly cookie/company context.
 */

export const getInvitations = async (params = {}) => {
  const { data } = await apiClient.get("/invitations", { params });
  return data;
};

export const createInvitation = async (body) => {
  const { companyId, ...cleanBody } = body || {};
  const { data } = await apiClient.post("/invitations", cleanBody);
  return data;
};

export const lookupInvitation = async (token) => {
  const { data } = await apiClient.get("/invitations/lookup", {
    params: { token },
  });
  return data;
};

export const acceptInvitation = async (token) => {
  const { data } = await apiClient.post("/invitations/accept", { token });
  return data;
};

export const resendInvitation = async (id) => {
  const { data } = await apiClient.post(`/invitations/${id}/resend`);
  return data;
};

export const revokeInvitation = async (id) => {
  const { data } = await apiClient.delete(`/invitations/${id}`);
  return data;
};
